import { VideoData } from '@cgs/wge';
import { TimeScaleComponent } from '@cgs/machines';

const BACKGROUND_VIDEO = 'slot_bg';

export class SantaTimeScaleComponent extends TimeScaleComponent {
  protected override eachVideo(callback: (videoData: VideoData, key: string) => void): void {
    super.eachVideo((videoData: VideoData, key: string) => {
      if (!key.includes(BACKGROUND_VIDEO)) {
        callback(videoData, key);
      }
    });
  }
}
